import { ApiService } from './ApiService';

export interface AgentflowDocResponse {
  data: {
    md: string | null;
  };
}

export class AgentflowDocService extends ApiService {
  static pathName = '/flow';

  static getDoc = (flowId: string): Promise<AgentflowDocResponse> => {
    return ApiService.get(`${this.pathName}/${flowId}/agentflow-doc`);
  };

  static updateDoc = (
    flowId: string,
    md: string,
  ): Promise<AgentflowDocResponse> => {
    return ApiService.patch(`${this.pathName}/${flowId}/agentflow-doc`, {
      md,
    });
  };

  static regenerateDoc = (flowId: string): Promise<AgentflowDocResponse> => {
    return ApiService.post(
      `${this.pathName}/${flowId}/agentflow-doc/regenerate`,
      {},
    );
  };
}
